import { classNames } from "primereact/utils";

import styles from "../empty-state.module.scss";
import { useEmptyStateContext } from "../empty-state.context";
import type { EmptyStateDescriptionProps } from "../types-empty-state";

export function EmptyStateDescription({
  children,
  className,
  ...rest
}: EmptyStateDescriptionProps) {
  const { partTestId, classNames: parts } = useEmptyStateContext();

  return (
    <p
      className={classNames(styles.description, parts.description, className)}
      data-testid={partTestId("description")}
      {...rest}
    >
      {children}
    </p>
  );
}
EmptyStateDescription.displayName = "EmptyState.Description";
